import { REDUCER } from '../reducers/reducersConst';
import { getLanguageFromStorage } from '../shared';
import { getDefaultLanguage } from '../services/translate/translateService';

/**
 * ACCOUNT DATA REDUCER
 */
let defaultAccountState = {
  newPasswordSent: false,
  newUserData: {},
  user: {
    language: getLanguageFromStorage() || getDefaultLanguage(),
    userId: null
  },
  configuration: {
    enableHomeView: true
  },
  userConfiguration: {},
  updatedUser: {},
  refreshModalIsOpen: false,
  jailed: false
};

/**
 * Account Reducer
 * @param state
 * @param action
 * @returns {*}
 */
export let account = (state = defaultAccountState, action) => {
  switch (action.type) {
    case REDUCER.ACCOUNT.NEW_PASSWORD_SENT:
      return {
        ...state,
        newPasswordSent: action.done
      };
    case REDUCER.ACCOUNT.SET_NEW_USER_DATA:
      return {
        ...state,
        newUserData: action.newUserData
      };
    case REDUCER.ACCOUNT.SET_USER_DATA:
      return {
        ...state,
        user: Object.assign(state.user, action.user)
      };
    case REDUCER.ACCOUNT.SET_USER_LANGUAGE:
      return {
        ...state,
        user: Object.assign(state.user, { language: action.language })
      };
    case REDUCER.ACCOUNT.SET_UPDATED_USER:
      return {
        ...state,
        updatedUser: action.updatedUser
      };
    case REDUCER.ACCOUNT.SET_USER_PICTURE:
      return {
        ...state,
        user: Object.assign({ picture: action.picture }, state.user)
      };
    case REDUCER.ACCOUNT.CONFIGURATION:
      return {
        ...state,
        configuration: action.configuration
      };
    case REDUCER.ACCOUNT.USER_CONFIGURATION:
      return {
        ...state,
        userConfiguration: action.configuration
      };
    case REDUCER.ACCOUNT.SET_REFRESH_MODAL_STATE:
      return {
        ...state,
        refreshModalIsOpen: action.refreshModalIsOpen
      };
    case REDUCER.ACCOUNT.SET_IS_ALREADY_FETCHING_TOKEN:
      return {
        ...state,
        isAlreadyFetchingToken: action.isAlreadyFetchingToken
      };
    case REDUCER.ACCOUNT.ADD_REQUEST_TOKEN_SUBSCRIBER:
      return {
        ...state,
        requestTokenSubscribers: [...state.requestTokenSubscribers, action.requestTokenSubscriber]
      };
    case REDUCER.ACCOUNT.SET_JAILED:
      return {
        ...state,
        jailed: action.jailed
      };
    default:
      return state;
  }
};

let defaultSignUpState = {
  formError: '',
  role: null
};

/**
 * SignUp Reducer
 * @param state
 * @param action
 * @returns {*}
 */
export let signUp = (state = defaultSignUpState, action) => {
  switch (action.type) {
    case REDUCER.SIGNUP.SET_USER_ROLE:
      return {
        ...state,
        role: action.role
      };
    case REDUCER.SIGNUP.SET_FORM_ERROR:
      return {
        ...state,
        formError: action.formError
      };
    default:
      return state;
  }
};
